export default __webpack_public_path__ + "b6c696562d18d78daa75766f54145903.png";